import type { ApiResponse, PagedResult } from "../../api/types";

export function unwrapApiResponse<T>(payload: ApiResponse<T> | T): T {
  if (payload && typeof payload === "object" && "data" in payload) {
    return (payload as ApiResponse<T>).data as T;
  }
  return payload as T;
}

export function unwrapPagedItems<T>(payload: ApiResponse<PagedResult<T>> | PagedResult<T> | T[]): {
  items: T[];
  total: number;
} {
  const data = unwrapApiResponse(payload as ApiResponse<PagedResult<T>> | PagedResult<T> | T[]);
  if (Array.isArray(data)) return { items: data, total: data.length };
  const items = data.items ?? data.data ?? data.records ?? [];
  return { items, total: data.totalCount ?? data.total ?? items.length };
}
